import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage: Storage;

  constructor() {
    this.storage = localStorage;
  }

  add(key: string, value: any): void {
    this.storage.setItem(key, value);
  }

  remove(key: string): void {
    this.storage.removeItem(key);
  }

  clearAll(): void {
    this.storage.clear();
  }

  get(key: string): any {
    const item = this.storage.getItem(key);
    return item ?? null
  }
}
